import cn from 'classnames';

import { IConDefaultType } from '..';

export enum PromotionBadgeIconVariant {
  ONE_PLUS_ONE = 'one_plus_one',
}

interface IPromotionBadgeIconProps extends IConDefaultType {
  variant?: PromotionBadgeIconVariant;
}

function PromotionBadgeIcon({
  className,
  size = 32,
  rotate,
  flip,
  variant = PromotionBadgeIconVariant.ONE_PLUS_ONE,
}: IPromotionBadgeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === PromotionBadgeIconVariant.ONE_PLUS_ONE && (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_15521_289008)">
            <path
              d="M13.356 1.56533C14.5743 -0.385574 17.4153 -0.385576 18.6336 1.56532L20.718 4.90304C21.2662 5.78078 22.2149 6.32851 23.2491 6.36435L27.1818 6.50064C29.4805 6.5803 30.901 9.04063 29.8206 11.0712L27.9723 14.5452C27.4862 15.4588 27.4862 16.5542 27.9723 17.4678L29.8206 20.9418C30.901 22.9724 29.4805 25.4327 27.1818 25.5124L23.2491 25.6487C22.2149 25.6845 21.2662 26.2322 20.718 27.11L18.6336 30.4477C17.4153 32.3986 14.5743 32.3986 13.356 30.4477L11.2716 27.11C10.7234 26.2322 9.77473 25.6845 8.74051 25.6487L4.80777 25.5124C2.50907 25.4327 1.08859 22.9724 2.16895 20.9418L4.0173 17.4678C4.50337 16.5542 4.50337 15.4588 4.0173 14.5452L2.16895 11.0712C1.08859 9.04064 2.50906 6.5803 4.80776 6.50064L8.74051 6.36435C9.77473 6.32851 10.7234 5.78078 11.2716 4.90304L13.356 1.56533Z"
              fill="url(#paint0_linear_15521_289008)"
            />
            <path
              d="M23.3255 12.0078V19.8881H21.6822V13.5643H21.6386L19.832 14.6962V13.2486L21.7801 12.0078H23.3255Z"
              fill="#0B6784"
            />
            <path
              d="M14.9922 18.6813V16.6459H12.957V15.2854H14.9922V13.25H16.3526V15.2854H18.3877V16.6459H16.3526V18.6813H14.9922Z"
              fill="#0B6784"
            />
            <path
              d="M10.8216 12.0078V19.8881H9.17825V13.5643H9.13472L7.32812 14.6962V13.2486L9.2762 12.0078H10.8216Z"
              fill="#0B6784"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_15521_289008"
              x1="8.99479"
              y1="3.56207"
              x2="26.8837"
              y2="31.5621"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#97FFF0" />
              <stop offset="1" stopColor="#16AECF" />
            </linearGradient>
            <clipPath id="clip0_15521_289008">
              <rect width="32" height="32" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </i>
  );
}

export default PromotionBadgeIcon;
